import { IFilterInformation } from '../../AdvancedFilters'

export const getAppliedCheckboxesAsArray = (
  optionsObject: Record<string, IFilterInformation>
): string[] => {
  return Object.keys(optionsObject)
    .map((key) => {
      if (optionsObject[key].checked) {
        return key
      }
      return ''
    })
    .filter((v) => v.length)
}
